import { VENTURES, LOGOS } from "../../data/ventures";
import { FadeUp, SectionLabel } from "./Reveal";

const RADIUS = 290;

export const Ecosystem = () => (
  <section id="ecosystem" data-testid="ecosystem-section" className="relative overflow-hidden py-24 md:py-32">
    <div className="pointer-events-none absolute left-1/2 top-1/2 h-[560px] w-[560px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-blue-600/10 blur-[150px]" />
    <div className="mx-auto max-w-[1440px] px-6 md:px-12">
      <div className="text-center">
        <FadeUp>
          <div className="flex justify-center">
            <SectionLabel>The Ecosystem</SectionLabel>
          </div>
        </FadeUp>
        <FadeUp delay={0.1}>
          <h2 className="mx-auto mt-6 max-w-3xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
            One core. <span className="text-gradient-cyan">Six orbits.</span>
          </h2>
        </FadeUp>
        <FadeUp delay={0.2}>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-slate-400">
            Every venture orbits the same engine. Hover to pause the system —
            click any orbit to visit the venture.
          </p>
        </FadeUp>
      </div>

      <FadeUp delay={0.15}>
        <div
          className="orbit-wrap relative mx-auto mt-8 hidden h-[780px] w-[780px] md:block"
          data-testid="ecosystem-orbital"
        >
          <div className="absolute inset-[90px] rounded-full border border-white/10" />
          <div className="absolute inset-[185px] rounded-full border border-dashed border-cyan-400/20 animate-spin-slow" />
          <div className="absolute inset-[285px] rounded-full border border-white/10" />

          <div className="absolute left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2 text-center">
            <div className="relative inline-block">
              <span className="absolute inset-0 -m-6 rounded-full bg-cyan-400/15 blur-2xl" />
              <img
                src={LOGOS.veerox}
                alt="Veerox Group"
                className="relative h-24 w-24 rounded-2xl object-cover ring-2 ring-cyan-400/40 shadow-[0_0_40px_rgba(0,229,255,0.35)]"
              />
            </div>
            <div className="mt-3 font-display text-sm font-bold tracking-wide text-white">
              VEEROX GROUP
            </div>
            <div className="font-mono-tech text-[0.55rem] uppercase tracking-[0.24em] text-slate-500">
              The Core
            </div>
          </div>

          <div className="orbit-spin absolute inset-0">
            {VENTURES.map((v, i) => {
              const angle = (i / VENTURES.length) * 360;
              return (
                <div
                  key={v.id}
                  className="absolute left-1/2 top-1/2"
                  style={{ transform: `rotate(${angle}deg) translateX(${RADIUS}px)` }}
                >
                  <div style={{ transform: `rotate(${-angle}deg)` }}>
                    <div className="orbit-counter">
                      <a
                        href={v.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid={`ecosystem-node-${v.id}`}
                        className="group block -translate-x-1/2 -translate-y-1/2 text-center"
                      >
                        <img
                          src={v.logo}
                          alt={v.name}
                          className="mx-auto h-24 w-24 rounded-2xl object-cover ring-2 ring-white/20 transition-transform duration-300 group-hover:scale-110"
                          style={{ boxShadow: `0 0 32px ${v.accent}55` }}
                        />
                        <span className="mt-2 block whitespace-nowrap rounded-full bg-slate-950/80 px-3 py-1 font-mono-tech text-[0.6rem] uppercase tracking-[0.16em] text-slate-200 ring-1 ring-white/10">
                          {v.name}
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </FadeUp>

      <div className="mt-12 grid grid-cols-3 gap-6 md:hidden" data-testid="ecosystem-mobile">
        {VENTURES.map((v) => (
          <a
            key={v.id}
            href={v.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center gap-2"
          >
            <img
              src={v.logo}
              alt={v.name}
              className="h-20 w-20 rounded-2xl object-cover ring-1 ring-white/15"
            />
            <span className="text-center font-mono-tech text-[0.5rem] uppercase tracking-wider text-slate-400">
              {v.name}
            </span>
          </a>
        ))}
      </div>
    </div>
  </section>
);
